import script from "./Navbar2.vue?vue&type=script&setup=true&lang=js"
export * from "./Navbar2.vue?vue&type=script&setup=true&lang=js"

import "./Navbar2.vue?vue&type=style&index=0&id=b060e73e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b060e73e"]])

export default __exports__